import { Routes, RouterModule, PreloadAllModules  } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';

import { ErrorComponent } from './trilce/error/error.component';
import { AuthGuardService } from './support/services/auth-guard.service';

export const routes: Routes = [
  { path: '', redirectTo: 'trilce', pathMatch: 'full' },
  { path: 'trilce', loadChildren: 'app/trilce/trilce.module#TrilceModule', canActivate: [AuthGuardService] },
  { path: 'login', loadChildren: 'app/trilce/login/login.module#LoginModule' },
  { path: 'cambio-contrasenia', loadChildren: 'app/trilce/cambio-contrasenia/cambio-contrasenia.module#CambioContraseniaModule' },
  { path: 'cambio-contrasenia/:UserName', loadChildren: 'app/trilce/cambio-contrasenia/cambio-contrasenia.module#CambioContraseniaModule' },
  { path: 'olvido-contrasenia', loadChildren: 'app/trilce/olvido-contrasenia/olvido-contrasenia.module#OlvidoContraseniaModule' },
  { path: 'restablecer-contrasenia', loadChildren: 'app/trilce/restablecer-contrasenia/restablecer-contrasenia.module#RestablecerContraseniaModule' },
  { path: 'restablecer-contrasenia/:Codigo', loadChildren: 'app/trilce/restablecer-contrasenia/restablecer-contrasenia.module#RestablecerContraseniaModule' },
  { path: '**', component: ErrorComponent },
  { path: 'error', component: ErrorComponent }
];

export const routing: ModuleWithProviders = RouterModule.forRoot(routes, {
    preloadingStrategy: PreloadAllModules,
    //useHash: true
});


// WEBPACK FOOTER //
// C:/Users/egila/Downloads/temp/20260608_NuevoSAT/Trilce.Presentacion.Intranet.Profesores.NG5/src/app/app.routing.ts